import baseUrl from './urls';
const apis: any = {
    getApis: {
        loginCaptcha: 'user/captcha-image', // 登录验证码
        userInfo: 'user/user-info', // 用户信息
        menuList: 'menu/index', // 左侧菜单栏
        streetList: 'street/index', // 街道列表
        collectiveTypeList: 'collective-type-original/index', // 全部产业集群列表
        industrialChainList: 'industrial-chain/index', // 全部产业链分类列表
        collectiveTypeDetail: 'collective-type-original/detail', // 产业集群-详情
        industrialChainDetail: 'industrial-chain/detail', // 产业链分类-详情
        collectiveGroupList: 'collective-type-group/index', // 产业集群列表（编组）
        industrialChainGroupList: 'industrial-chain-group/index', // 产业链分类列表（编组）
        collectiveGroupDetail: 'collective-type-group/detail', // 产业集群-（编组）详情
        industrialChainGroupDetail: 'industrial-chain-group/detail', // 产业链分类-（编组）详情
        committeeList: 'committee/index', // 产业集群-专家委员会列表
        committeeDetail: 'committee/detail', // 产业集群-专家委员会详情
        streetDetail: 'street/detail', // 街道详情
        industryPolicyList: 'street-chan-ye-zheng-ce/index', // 街道产业政策列表
        industryPolicyDetail: 'street-chan-ye-zheng-ce/detail', // 街道产业政策详情
        convergenceMediaList: 'street-rong-mei-ti/index', // 街道融媒体列表
        convergenceMediaDetail: 'street-rong-mei-ti/detail', // 街道产业政策详情
        investorList: 'investor/index', // 投资机构列表
        investorDetail: 'investor/detail', // 投资机构详情
        investorBusinessPlanList: '', // 投资机构-商业计划书列表
        investorBusinessPlanDetail: '', // 投资机构-商业计划书详情
        studyList: 'study/index', // 院校列表
        studyDetail: 'study/detail', // 院校详情
        studyExpertList: 'study-expert/index', // 院校-专家列表
        studyExpertDetail: 'study-expert/detail', // 院校-专家详情
        studyLaboratoryList: 'study-laboratory/index', // 院校-实验室列表
        studyLaboratoryDetail: 'study-laboratory/detail', // 院校-实验室详情
        studyAchievementList: 'study-cheng-guo/index', // 院校-成果列表
        studyAchievementDetail: 'study-cheng-guo/detail', // 院校-成果详情
        studyPublicationList: 'study-publication/index', // 院校-出版物列表
        studyPublicationDetail: 'study-publication/detail', // 院校-出版物详情
        studyMeetingList: 'study-meeting/index', // 院校-活动列表
        studyMeetingDetail: 'study-meeting/detail', // 院校-活动详情
        associationList: 'association/index', // 协会列表
        associationDetail: 'association/detail', // 协会详情
        associationLeaderList: 'association-leaders/index', // 协会-领导列表
        associationLeaderDetail: 'association-leaders/detail', // 协会-领导详情
        associationDynamicList: 'association-dynamic/index', // 协会-动态列表
        associationDynamicDetail: 'association-dynamic/detail', // 协会-动态详情
        industryDynamicList: 'association-industry-dynamic/index', // 协会-产业动态列表
        industryDynamicDetail: 'association-industry-dynamic/detail', // 协会-产业动态详情
        associationMemberList: 'association-publication/index', // 协会-会员列表
        associationMemberDetail: 'association-publication/detail', // 协会-会员详情
        bankList: 'bank/index', // 分行列表
        bankDetail: 'bank/detail', // 分行详情
        branchBankList: 'bank-branch/index', // 支行列表
        branchBankDetail: 'bank-branch/detail', // 支行详情
        operatorList: 'operator/index', // 运营商列表
        operatorDetail: 'operator/detail', // 运营商详情
        serviceProviderList: 'service-provider/index', // 服务商列表
        serviceProviderDetail: 'service-provider/detail', // 服务商详情
        gardenList: 'garden/index', // 园区列表
        gardenDetail: 'garden/detail', // 园区详情
        gardenPolicyList: 'garden-zheng-ce/index', // 园区-招商政策列表
        gardenPolicyDetail: 'garden-zheng-ce/detail', // 园区-招商政策详情
        gardenNewsList: 'garden-news/index', // 园区-园区动态列表
        gardenNewsDetail: 'garden-news/detail', // 园区-园区动态详情
        messagePostList: 'message-post/index', // 产业定制列表
        messagePostDetail: 'message-post/detail', // 产业定制详情
        companyList: 'company/index', // 企业列表
        companyDetail: 'company/detail', // 企业详情
        communalIndex: 'communal/index', // 上市分类（原行业分类）
        shareholderList: 'company-gu-dong-group-member/index', // 企业-股东列表
        shareholderDetail: 'company-gu-dong-group-member/detail', // 企业-股东详情
        seniorList: 'company-manage-member/index', // 企业-高管列表
        seniorDetail: 'company-manage-member/detail', // 企业-高管详情
        financialStatementList: 'company-cai-wu-zhi-biao/index', // 企业-财务指标列表
        financialStatementDetail: 'company-cai-wu-zhi-biao/detail', // 企业-财务指标详情
        financialReportList: 'company-cai-wu-bao-gao/index', // 企业-财务报告列表
        financialReportDetail: 'company-cai-wu-bao-gao/detail', // 企业-财务报告详情
        companyNoticeList: 'affiche/index', // 企业-相关公告列表
        companyNoticeDetail: 'affiche/detail', // 企业-相关公告详情
        researchList: 'research/index', // 产业研究列表
        researchDetail: 'research/detail', // 产业研究详情
        informationList: 'information/index', // 通知文章列表
        informationDetail: 'information/detail', // 通知文章详情
        hatchingList: 'hatching/index', // 孵化成果列表
        hatchingDetail: 'hatching/detail', // 孵化成果详情
        lawsList: 'laws/index', // 法律法规列表
        lawsDetail: 'laws/detail', // 法律法规详情
        ruleList: 'rule/index', // 红筹规则列表
        ruleDetail: 'rule/detail', // 红筹规则详情
        articlesList: 'articles/index', // 文章列表（文章总库）
        articlesDetail: 'articles-cate/detail', // 文章详情
        articlesPushList: 'articles-cate/index', // 文章列表-发布列表
        articlesPushDetail: 'articles-cate/detail', // 文章详情-发布列表
        financingOrderList: 'financing-order/index', // 融资信息-办理/审核/小程序客户列表
        financingOrderDetail: 'financing-order/detail', // 融资信息详情-办理/审核/小程序客户
        financingHandleList: 'financing-order-handle/index', // 融资信息-银行/服务商办理列表
        financingHandleDetail: 'financing-order-handle/detail', // 融资信息详情-银行/服务商办理
        financingInformationList: 'financing-information-record/index', // 融资信息-p2ipo客户列表
        financingInformationDetail: 'financing-information-record/detail', // 融资信息详情-p2ipo客户
        financingMatterList: 'financing-order-matter/index', // 融资信息-授信评估列表
        financingMatterDetail: 'financing-order-matter/detail', // 融资信息详情-授信评估
        deleteApprovalList: 'delete-approval/index', // 删除审核列表
        deleteApprovalDetail: 'delete-approval/detail', // 删除审核详情
        repeatClaimList: 'repeat-claim/index', // 重复领取列表
        repeatClaimDetail: 'repeat-claim/detail', // 重复领取详情
        recommendBusinessList: 'recommend-business/index', // 支行推荐业务列表
        recommendBusinessDetail: 'recommend-business/detail', // 支行推荐业务详情
        bankProductList: 'bank-product/index', // 银行产品列表
        bankProductDetail: 'bank-product/detail', // 银行产品详情
        bankProductUpList: 'bank-product/up-index', // 银企快车产品列表
        feedbackList: 'feedback/index', // 反馈信息列表（我发送的）
        feedbackReceiveList: 'feedback/receive', // 反馈信息列表（我接收的）
        feedbackDetail: 'feedback/detail', // 反馈信息详情
        systemNoticeList: 'notice/index', // 系统通知列表
        systemNoticeDetail: 'notice/detail', // 系统通知详情
        clearStorage: 'site/flush-cache', // 清空缓存
        streetAreaList:'street-area/index', //省市区街道列表
        streetAreaDetail: 'street-area/detail', // 获取街道详情
    },
    postApis: {
        loginCaptcha: 'user/captcha', // 登录验证码
        login: 'user/login', // 用户登录
        userPasswordReset: 'user/reset-password', // 用户密码初始化
        userChangePassword: 'user/change-password', // 用户修改密码
        uploadFile: 'upload-file/store', // 上传
        menuEdit: 'menu/edit', // 编辑菜单
        streetEdit: 'street/edit', // 街道编辑
        industryPolicyEdit: 'street-chan-ye-zheng-ce/edit', // 街道产业政策编辑
        industryPolicyDelete: 'street-chan-ye-zheng-ce/destroy', // 街道产业政策删除
        convergenceMediaEdit: 'street-rong-mei-ti/edit', // 街道融媒体编辑
        convergenceMediaDelete: 'street-rong-mei-ti/destroy', // 街道融媒体删除
        investorEdit: 'investor/edit', // 投资机构编辑
        investorDelete: 'investor/destroy', // 投资机构删除
        investorBusinessPlanDelete: '', // 投资机构-商业计划书删除
        studyEdit: 'study/edit', // 院校编辑
        studyDelete: 'study/destroy', // 院校删除
        studyExpertEdit: 'study-expert/edit', // 院校-专家编辑
        studyExpertDelete: 'study-expert/destroy', // 院校-专家删除
        studyLaboratoryEdit: 'study-laboratory/edit', // 院校-实验室编辑
        studyLaboratoryDelete: 'study-laboratory/destroy', // 院校-实验室删除
        studyAchievementEdit: 'study-cheng-guo/edit', // 院校-成果编辑
        studyAchievementDelete: 'study-cheng-guo/destroy', // 院校-成果删除
        studyPublicationEdit: 'study-publication/edit', // 院校-出版物编辑
        studyPublicationDelete: 'study-publication/destroy', // 院校-出版物删除
        studyMeetingEdit: 'study-meeting/edit', // 院校-活动编辑
        studyMeetingDelete: 'study-meeting/destroy', // 院校-活动删除
        associationEdit: 'association/edit', // 协会编辑
        associationDelete: 'association/destroy', // 协会删除
        associationHidden: 'association/switch-title', // 协会-名称显示/隐藏
        associationStatus: 'association/switch-status', // 协会-详情显示/隐藏
        associationLeaderEdit: 'association-leaders/edit', // 协会-领导编辑
        associationLeaderDelete: 'association-leaders/destroy', // 协会-领导删除
        associationDynamicEdit: 'association-dynamic/edit', // 协会-动态编辑
        associationDynamicDelete: 'association-dynamic/destroy', // 协会-动态删除
        industryDynamicEdit: 'association-industry-dynamic/edit', // 协会-产业动态编辑
        industryDynamicDelete: 'association-industry-dynamic/destroy', // 协会-产业动态删除
        associationMemberEdit: 'association-publication/edit', // 协会-会员编辑
        associationMemberDelete: 'association-publication/destroy', // 协会-会员删除
        associationMemberReceive: 'association/receive-company', // 协会-会员挑选（领取）
        bankEdit: 'bank/edit', // 分行编辑
        bankDelete: 'bank/destroy', // 分行删除
        branchBankEdit: 'bank-branch/edit', // 支行编辑
        branchBankDelete: 'bank-branch/destroy', // 支行删除
        operatorEdit: 'operator/edit', // 运营商编辑
        operatorDelete: 'operator/destroy', // 运营商删除
        serviceProviderEdit: 'service-provider/edit', // 服务商编辑
        serviceProviderDelete: 'service-provider/destroy', // 服务商删除
        gardenEdit: 'garden/edit', // 园区编辑
        gardenSet: 'garden/set', // 园区设置
        gardenDelete: 'garden/destroy', // 园区删除
        gardenReceiveCompany: 'garden/receive-company', // 园区-领取企业
        gardenPolicyEdit: 'garden-zheng-ce/edit', // 园区-招商政策编辑
        gardenPolicyDelete: 'garden-zheng-ce/destroy', // 园区-招商政策删除
        gardenNewsEdit: 'garden-news/edit', // 园区-园区动态编辑
        gardenNewsDelete: 'garden-news/destroy', // 园区-园区动态删除
        messagePostDelete: 'message-post/destroy', // 产业定制删除
        companyEdit: 'company/edit', // 企业编辑
        companyDelete: 'company/destroy', // 企业删除
        shareholderEdit: 'company-gu-dong-group-member/edit', // 企业-股东编辑
        shareholderDelete: 'company-gu-dong-group-member/destroy', // 企业-股东删除
        seniorEdit: 'company-manage-member/edit', // 企业-高管编辑
        seniorDelete: 'company-manage-member/destroy', // 企业-高管删除
        financialStatementEdit: 'company-cai-wu-zhi-biao/edit', // 企业-财务指标编辑
        financialStatementDelete: 'company-cai-wu-zhi-biao/destroy', // 企业-财务指标删除
        financialReportEdit: 'company-cai-wu-bao-gao/edit', // 企业-财务报告编辑
        financialReportDelete: 'company-cai-wu-bao-gao/destroy', // 企业-财务报告删除
        companyNoticeEdit: 'affiche/edit', // 企业-相关公告编辑
        companyNoticeDelete: 'affiche/destroy', // 企业-相关公告删除
        collectiveTypeEdit: 'collective-type-original/edit', // 产业集群-编辑
        industrialChainEdit: 'industrial-chain/edit', // 产业链分类-编辑
        collectiveTypeHidden: 'collective-type-original/switch-hidden', // 产业集群-显示/隐藏
        collectiveTypeBold: 'collective-type-original/switch-bold', // 产业集群-字体加粗
        industrialChainHidden: 'industrial-chain/switch-hidden', // 产业链分类-显示/隐藏
        collectiveTypeDelete: 'collective-type-original/destroy', // 产业集群-删除
        industrialChainDelete: 'industrial-chain/destroy', // 产业链分类-删除
        collectiveGroupAdd: 'collective-type-group/edit', // 产业集群-编组-添加一级
        industrialChainGroupEdit: 'industrial-chain-group/edit', // 产业链分类-编组-添加
        collectiveGroupAddChild: 'collective-type-group/edit-children', // 产业集群-编组-添加子级
        // industrialChainGroupAddChild: 'industrial-chain-group/edit-children', // 产业链分类-编组-添加子级
        collectiveGroupDelete: 'collective-type-group/destroy', // 产业集群-删除编组
        industrialChainGroupDelete: 'industrial-chain-group/destroy', // 产业链分类-删除编组
        collectiveGroupCut: 'collective-type-group/cut', // 产业集群-编组-剪切
        industrialChainGroupCut: 'industrial-chain-group/cut', // 产业链分类-编组-剪切
        collectiveGroupCopy: 'collective-type-group/copy', // 产业集群-编组-复制
        industrialChainGroupCopy: 'industrial-chain-group/copy', // 产业链分类-编组-复制
        committeeEdit: 'committee/edit', // 产业集群-专家委员会编辑
        committeeDelete: 'committee/destroy', // 产业集群-专家委员会删除
        domeStreetSet: 'collective-type-group/demo-street', // 产业地图-设置示范街道
        domeStreetCancel: 'collective-type-group/cancel-demo-street', // 产业地图-取消示范街道
        receiveStreetSet: 'collective-type-group/receive-street', // 产业地图-设置相关街道（关联）
        receiveStreetCancel: 'collective-type-group/cancel-receive-street', // 产业地图-取消相关街道（解绑）
        domeGardenSet: 'collective-type-group/demo-garden', // 产业地图-设置示范园区
        domeGardenCancel: 'collective-type-group/cancel-demo-garden', // 产业地图-取消示范园区
        receiveGardenSet: 'collective-type-group/receive-garden', // 产业地图-设置相关园区（关联）
        receiveGardenCancel: 'collective-type-group/cancel-receive-garden', // 产业地图-取消相关园区（解绑）
        researchEdit: 'research/edit', // 产业研究编辑
        researchDelete: 'research/destroy', // 产业研究删除
        collectiveReceiveCompany: 'collective-type-group/receive-company', // 产业集群-产业链-领取企业
        collectiveCancelReceiveCompany: 'collective-type-group/cancel-receive-company', // 产业集群-产业链-企业取消关联
        receiveAssociation: 'collective-type-group/receive-association', // 产业集群-领取协会
        receiveAssociationCancel: 'collective-type-group/cancel-receive-association', // 产业集群-协会取消关联
        informationEdit: 'information/edit', // 通知文章编辑
        informationDelete: 'information/destroy', // 通知文章删除
        hatchingEdit: 'hatching/edit', // 孵化成果编辑
        hatchingDelete: 'hatching/destroy', // 孵化成果删除
        lawsEdit: 'laws/edit', // 法律法规编辑
        lawsDelete: 'laws/destroy', // 法律法规删除
        ruleEdit: 'rule/edit', // 红筹规则编辑
        ruleDelete: 'rule/destroy', // 红筹规则删除
        articlesEdit: 'articles/edit', // 文章编辑
        articlesDelete: 'articles/destroy', // 文章删除
        articlesPushEdit: 'articles-cate/edit', // 文章编辑-发布列表
        articlesPushDelete: 'articles-cate/destroy', // 文章删除-发布列表
        articlesPushCate: 'articles-cate/push-cate', // 文章推送
        articlesPush: 'articles-cate/push', // 文章推送至产业集群
        financingOrderDelete: 'financing-order/destroy', // 融资信息删除-办理/审核/小程序客户
        financingHandleDelete: 'financing-order-handle/destroy', // 融资信息删除-银行/服务商办理
        financingInformationDelete: 'financing-information-record/destroy', // 融资信息删除-p2ipo客户
        financingMatterDelete: 'financing-order-matter/destroy', // 融资信息删除-授信评估
        bankProductEdit: 'bank-product/edit', // 银行产品编辑
        bankProductDelete: 'bank-product/destroy', // 银行产品删除
        bankProductLock: 'bank-product/switch-hidden', // 银行产品锁定
        bankProductTop: 'bank-product/top', // 银行产品置顶
        bankProductStatus: 'bank-product/switch-status', // 银行产品切换状态
        feedbackEdit: 'feedback/edit', // 反馈信息编辑-单
        feedbackPush: 'feedback/push', // 反馈信息编辑-多
        feedbackDelete: 'feedback/destroy', // 反馈信息删除
        bankProductApply: 'financing-information-record/apply', // 银行产品申请
        studyBatchSet:'study/collective-type-set',//学术 批量设置产业集群
        committeeBatchSet:'committee/collective-type-set',//专家 批量设置产业集群
        researchBatchSet:'research/collective-type-set',//产业研究 批量设置产业集群
        studyMeetingBatchSet:'study-meeting/collective-type-set',//活动 批量设置产业集群
        collectiveTypeSet: 'street-area/collective-type-set', // 街道设置产业集群
        streetAreaEdit: 'street-area/edit', // 街道编辑
    }
};
Object.keys(apis.postApis).forEach(key => {
    apis.postApis[key] = baseUrl + '?r=' + apis.postApis[key];
});
export default apis;